import React from "react"
import controllers_pic from "../images/band_controllers.jpg"
import blue_pic from "../images/2026_may_blue.JPG"
import red_pic from "../images/2026_may_red_pic.JPG"
import dressing_room from "../images/2026_may_dressing_room.JPG"
import red_pic_web from "../images/hero_red_web.jpg"
import controllers_pic_web from "../images/band_controllers_web.jpg"
import blue_pic_web from "../images/blue_web.jpg"
import dressing_room_web from "../images/dressing_room_web.jpg"
import "./Epk.css"

// thumbnails use the web-sized copies; downloads get the full-resolution originals
const PHOTOS = [
    { full: red_pic, thumb: red_pic_web, name: "lowfye50-red.jpg" },
    { full: controllers_pic, thumb: controllers_pic_web, name: "lowfye50-controllers.jpg" },
    { full: blue_pic, thumb: blue_pic_web, name: "lowfye50-blue.jpg" },
    { full: dressing_room, thumb: dressing_room_web, name: "lowfye50-dressing-room.jpg" },
]

export const PhotoSection = () => (
    <div className="lf-photos">
        {PHOTOS.map(photo => (
            <a key={photo.name} className="lf-photo" href={photo.full} download={photo.name}>
                <img src={photo.thumb} alt="Lowfye50 band shot" loading="lazy" />
                <span className="lf-photo__dl"><i className="fas fa-download"></i> Hi-res</span>
            </a>
        ))}
    </div>
)
